import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.default-subroute')

// nosemgrep: express-data-exfiltration
export default function (route, from, next) {
  logger.debug(route.path)

  /*
   * does not work for "/" but we don't need
   * shortcut, because "default-route" guard
   * takes precedense
   */
  const r = typeof route.meta?.defaultSubroute === 'function'
    ? route.meta.defaultSubroute() : route.meta?.defaultSubroute
  if (r && r.name) {
    logger.debug(`redirecting to "${r.name}" view...`)
    next({
      name: r.name,
      params: Object.assign(route.params || {}, r.params || {}),
      query: Object.assign(route.query || {}, r.query || {}),
    })
  } else {
    next()
  }
}
